    <div class="grid mt-2">
        <sm-overview-box *ngFor="let def of definitions" class="col-12 md:col-6 lg:col-3" [count]="def.resultCount"
            [text]="def.name" [icon]="def.icon" [boxColor]="def.boxColor" (click2)="click(def)">
        </sm-overview-box>
    </div>
